// Remove no-js as early as possible
document.documentElement.classList.remove('no-js');

// Set ticker height → exposes --sar61-ticker-h on :root
(function () {
    function setTickerVar() {
        const el = document.querySelector('.sar61-ticker');
        const h = el ? Math.round(el.getBoundingClientRect().height) : 0;
        document.documentElement.style.setProperty('--sar61-ticker-h', `${h}px`);
    }

    window.addEventListener('DOMContentLoaded', setTickerVar);
    window.addEventListener('resize', setTickerVar);

    const obs = new MutationObserver(setTickerVar);
    obs.observe(document.documentElement, { childList: true, subtree: true });
})();

// Mobile nav toggle
(function () {
    const toggleBtn = document.querySelector('[data-sar61-toggle-nav]');
    const navWrapper = document.querySelector('[data-sar61-nav]');
    const header = document.querySelector('.site-header');

    if (!toggleBtn || !navWrapper || !header) return;

    toggleBtn.addEventListener('click', () => {
        const isOpen = navWrapper.classList.toggle('is-open');

        toggleBtn.classList.toggle('is-open', isOpen);
        toggleBtn.setAttribute('aria-expanded', String(isOpen));

        header.classList.toggle('menu-open', isOpen);
        document.body.classList.toggle('no-scroll', isOpen);
    });
})();

// Dropdown menus
(function () {
    const menuItems = document.querySelectorAll('.menu-item-has-children');

    function closeAll() {
        menuItems.forEach(item => item.classList.remove('is-open'));
    }

    menuItems.forEach(item => {
        const link = item.querySelector(':scope > a');
        const submenu = item.querySelector(':scope > .sub-menu');

        if (!link || !submenu) return;

        link.addEventListener('click', e => {
            if (window.innerWidth < 1024) return;

            e.preventDefault();
            const isOpen = item.classList.contains('is-open');
            closeAll();

            if (!isOpen) {
                item.classList.add('is-open');
            }
        });
    });

    document.addEventListener('click', e => {
        const isClickInside = [...menuItems].some(item => item.contains(e.target));
        if (!isClickInside) {
            closeAll();
        }
    });
})();

function renderAuthActions(isLoggedIn) {
    const wrappers = document.querySelectorAll('[data-header-auth]');

    wrappers.forEach(wrapper => {
        const mode = wrapper.getAttribute('data-header-auth');

        if (mode === 'desktop') {
            wrapper.innerHTML = isLoggedIn
                ? `<a class="header-auth__login" href="/min-side">Min side</a>`
                : `
                    <a class="header-auth__login" href="/min-side">Logg inn</a>
                    <a class="header-auth__signup" href="/min-side">Meld deg på</a>
                  `;
            return;
        }

        if (mode === 'mobile-cta') {
            wrapper.innerHTML = isLoggedIn
                ? ``
                : `<a class="header-auth__signup" href="/min-side">Meld deg på</a>`;
            return;
        }

        if (mode === 'mobile-menu') {
            wrapper.innerHTML = isLoggedIn
                ? `<a class="header-auth__login" href="/min-side">Min side</a>`
                : `
                    <a class="header-auth__login" href="/min-side">Logg inn</a>
                    <a class="header-auth__signup" href="/min-side">Meld deg på</a>
                  `;
        }
    });
}

async function updateAuthHeader() {
    try {
        const res = await fetch('/api/auth/auth_status.php', {
            method: 'GET',
            credentials: 'include',
            cache: 'no-store'
        });

        const json = await res.json();
        const isLoggedIn = Boolean(json?.success && json?.data?.logged_in);

        renderAuthActions(isLoggedIn);
    } catch (err) {
        renderAuthActions(false);
    }
}

document.addEventListener('DOMContentLoaded', updateAuthHeader);
document.addEventListener('sar61:auth-changed', e => {
    const isLoggedIn = Boolean(e.detail?.loggedIn);
    renderAuthActions(isLoggedIn);
});
